export default {"src":"/_next/static/media/jumping-kid.b41e3d39.svg","height":580,"width":750,"blurWidth":0,"blurHeight":0};